import React from "react";
import { useState } from "react";
import {
  deleteSessionService,
  getActiveProgramById,
  getActiveSession,
  getSessionDaysService,
  getSIngleSession,
  putSIngleActiveSession,
} from "../../services/ActivePrograms";
import { useEffect } from "react";
import {
  changeDateFormatmmddyyyy,
  checkEndDate,
  dateSort,
  formatAMPM,
  isEmpty,
  onStartSession,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import DurationSvg from "../../svg/DurationAddSession.svg";
import Loader from "../../commonComponent/Loader";
import Button from "../../commonComponent/Button";
import { createZoomMeetingService } from "../../services/ZoomService";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../commonComponent/DeleteModal";
import {
  RiDeleteBin5Fill,
  RiEdit2Fill,
  RiEyeFill,
  RiPlayFill,
} from "react-icons/ri";
import { format } from "date-fns";
import DateInput from "../../commonComponent/CutomDatePicker";
import ActiveSessionModel from "./ActiveSessionModel";
import ViewSession from "./ViewSession";
import { getAvailableSessionSlots } from "../../services/DoctorService";
import moment from "moment";
import { IoIosMore } from "react-icons/io";
import { IoArrowBack } from "react-icons/io5";

const ActiveSessionView = (props) => {
  const navigate = useNavigate();
  const programId = props.programId;
  const [viewSession, setViewSession] = useState(false);
  const [session, setSession] = useState();
  const [programDetails, setProgramDetails] = useState({});
  const [getSessionList, setGetSessionList] = useState([]);
  const [sessionDays, setSessionDays] = useState("");
  const [isLoading, setLoader] = useState(true);
  const [sessionId, setSessionId] = useState("");
  const [sessionApiChange, setSessionApiChange] = useState("");
  const [zoomlink, setZoomlink] = useState(false);
  const [meetLocation, setMeetLocation] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [description, setDescription] = useState("");
  const [sessionStartTime, setSessionStartTime] = useState("");
  const [sessionEndTime, setSessionEndTime] = useState("");
  const [sessionDate, setSessionDate] = useState(new Date());
  const [error, setError] = useState(false);
  const [timeList, setTimeList] = useState([]);
  const [isSubmit, setSubmit] = useState(false);
  const [sessionTime, setSessionTime] = useState("");
  const [Duration, setDuration] = useState("");
  const urlPattern = new RegExp(
    "((http|https)://)(www.)?" +
      "[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]" +
      "{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)"
  );

  useEffect(() => {
    getSessionById();
    getSessionDays();
    getActiveProgramByIds();
  }, [programId]);
  useEffect(() => {
    if (
      Duration === "30" ||
      Duration === "60" ||
      Duration === "90" ||
      Duration === "120"
    ) {
      getTimeSlots(format(sessionDate, "yyyy-MM-dd"));
    }
  }, [Duration, sessionDate]);

  const getActiveProgramByIds = async () => {
    setLoader(true);
    // console.log(sessionId);
    try {
      const response = await getActiveProgramById(programId);
      if (response.status === 200 && response?.data) {
        setProgramDetails(response?.data?.data);
      } else {
        console.log(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.data || error.message);
      setLoader(false);
    }
  };
  const getSessionDays = async () => {
    try {
      const response = await getSessionDaysService(programId);
      if (response) {
        setSessionDays(response);
      }
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(sessionWeeks)
  const getSessionById = async () => {
    try {
      const response = await getActiveSession(programId);
      setLoader(false);
      if (response.status === 200) {
        setGetSessionList(response?.data?.data);
      }
    } catch (error) {
      setLoader(false);
      setGetSessionList([]);
    }
  };

  const getTimeSlots = async (date) => {
    try {
      const response = await getAvailableSessionSlots(date, Duration);
      if (response.status === 200) {
        setTimeList(
          response.data.data.length > 0 ? dateSort(response?.data?.data) : []
        );
      } else {
        alert(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data && alert(error?.data?.data || error.data?.message);
    }
  };

  const getSIngleSessionById = async (sessionId) => {
    setLoader(true);
    try {
      if (!sessionId) {
        return;
      }
      const response = await getSIngleSession(programId, sessionId);
      if (response.status === 200 && response?.data?.data) {
        const session = response.data.data;
        setSessionName(session.title);
        setMeetLocation(session.sessionLink_doctor);
        setZoomlink(urlPattern.test(session.sessionLink_doctor) ? true : false);
        setSessionTime(session.sessionTime);
        setSessionStartTime(session.startTime);
        setSessionEndTime(session.endTime);
        setDescription(session.description);
        const diff =
          new Date(session.endTime).getTime() -
          new Date(session.startTime).getTime();
        setDuration(diff / 60000);
        setSessionDate(new Date(session.sessionDate));
      } else {
        console.log(response?.data || response.message);
      }
      setLoader(false);
    } catch (error) {
      error?.data?.data &&
        console.log(error?.data?.data || error.data?.message);
      setLoader(false);
    }
  };

  const renderError = (msg, value) => {
    return value ? (
      <h6
        className="blog_error_text4"
        style={{ marginBottom: 15, marginTop: -15 }}
      >
        {msg}
      </h6>
    ) : null;
  };

  const checkValidation = () => {
    try {
      let errorsResult = error;
      let isValid = true;

      if (!sessionName || isEmpty(sessionName)) {
        isValid = false;
        errorsResult = { ...errorsResult, sessionName: true };
      }
      if (!description || isEmpty(description)) {
        isValid = false;
        errorsResult = { ...errorsResult, description: true };
      }
      if (!sessionStartTime || isEmpty(sessionStartTime)) {
        isValid = false;
        errorsResult = { ...errorsResult, startTime: true };
      }

      setError(errorsResult);

      return isValid;
    } catch (error) {}
  };
  const getDate = (date) => {
    try {
      if (date && new Date(date) !== "Invalid Date") {
        return new Date(date);
      }
      // return new Date()
    } catch (error) {}
  };
  const startDateCreate = getDate(programDetails[0]?.startDate);
  const endDateCreate = getDate(programDetails[0]?.endDate);

  const handleSubmitSession = async (e) => {
    // const sessionTimeEdit = sessionTime.split(" ");

    e.preventDefault();
    if (!checkValidation()) {
      return;
    }
    setSubmit(true);
    // const sessionD = session.toString();
    if (sessionApiChange === "edit") {
      try {
        const sessionD = format(sessionDate, "yyyy-MM-dd");
        var parms = {
          programId: programId,
          title: sessionName,
          sessionDate: sessionD,
          startTime: sessionStartTime,
          endTime: sessionEndTime,
          description: description,
          // "session_timezone": sessionTimeZone,
          sessionId: sessionId,
          sessionLink_doctor: meetLocation,
          sessionLink_user: meetLocation,
        };

        if (zoomlink && !urlPattern.test(meetLocation)) {
          const meetingResponse = await createMeetingsome();
          // console.log("after response", meetingResponse);

          parms.sessionLink_doctor = meetingResponse.start_url;
          parms.sessionLink_user = meetingResponse.join_url;
        }
        // console.log("here somewhere");

        const response = await putSIngleActiveSession(parms);
        // setShowLoader(false)
        setSubmit(false);
        if (response.status === 200) {
          // props.onSave();
          document.getElementById("btn-close").click();
          showToastSuccess(`Active session is updated`);
          getSessionById();
        } else {
          showToastError(
            response?.data || response.message || "Some error occurred"
          );
        }
      } catch (error) {
        // setShowLoader(false)
        showToastError(
          error?.data?.data || error.data?.message || "Catch error occurred"
        );
        console.error("Error in handleSubmitSession:", error);
      }
    }
  };

  const createMeetingsome = async () => {
    try {
      const meetingDetail = {
        topic: programDetails?.programName,
        type: 8,
        start_time: sessionStartTime,
        duration: "60",
        recurrence: {
          end_date_time: sessionEndTime,
          monthly_week: 1,
          monthly_week_day: 1,
          repeat_interval: 2,
          type: 2,
        },
        settings: {
          host_video: true,
          participant_video: true,
          join_before_host: true,
          mute_upon_entry: "true",
          watermark: "true",
          audio: "voip",
          auto_recording: "cloud",
          email_notification: true,
          registrants_email_notification: true,
        },
      };

      // console.log(
      //   "Inside createMeetingService. Meeting detail:",
      //   meetingDetail
      // );

      const res = await createZoomMeetingService(meetingDetail);

      console.error("Meeting service response:", error);

      if (res) {
        console.log("here response");
        return res;
      }
    } catch (error) {
      if (error?.data?.data) {
        navigate("/myprofile");
        showToastError(
          error?.data?.data || error.data?.message || "Some error occurred"
        );
        console.error("Error in createMeeting:", error);
        throw error;
      }
    }
  };

  const deleteSession = async (sessionId) => {
    try {
      const response = await deleteSessionService(sessionId, programId);
      if (response) {
        showToastSuccess(response?.data || "Session deleted successfully.");
        getSessionById();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || "Some error occurred"
      );
    }
  };

  // const renderSessionList = () => {
  //     return getSessionList.map((session, index) => {
  //         var stime = new Date(session?.startTime).getTime();
  //         var etime = new Date(session?.endTime).getTime();
  //         var ctime = new Date().getTime();
  //         const canStartSession = !checkEndDate(session.sessionDate);
  //         var time = new Date(session.createdAt);
  //         return (
  //             <div className="d-flex mb-3">
  //                 <span className="px-3 py-3 numbr">{index + 1 < 10 && "0"}{index + 1}</span>
  //                 <div className="flex-grow-1 card d-flex px-4 py-3 flex-row justify-content-between align-items-center">
  //                     <div>
  //                         <h5>{session.title}</h5>
  //                         <p className="mb-0">{changeDateFormatmmddyyyy(session.sessionDate)}</p>
  //                     </div>
  //                     <button
  //                         className="btn btn-primary btn-custom-light"
  //                         data-bs-toggle="modal" data-bs-target="#exampleModal"
  //                         disabled={auth?.authUser?._id !== session?.createdById || !canStartSession || !(ctime >= stime) || !(ctime <= etime)} onClick={() => canStartSession && auth?.authUser?._id === session?.createdById && onStartSession(session?.sessionLink_doctor)} style={{ backgroundColor: canStartSession ? null : '#d81010' }}
  //                     >
  //                         {canStartSession ? 'start session' : 'session completed'}
  //                     </button>
  //                 </div>
  //             </div>
  //         );
  //     })
  // }
  const RenderSesstionItem = ({session}) => {
    const [dropDown, setDropDown] = useState(false);
    const drop = `dropdown-menu${dropDown ? " show" : ""}`;
    const canStartSession = !checkEndDate(session.sessionDate);
    return (
      <>
        <div className="d-flex mb-3">
          {/* <span className="px-3 py-3 numbr">
                {index + 1 < 10 && "0"}
                {index + 1}
              </span> */}
          <div className="flex-grow-1 card d-flex ps-4 py-3 flex-row justify-content-between align-items-center">
            <div>
              <h5>{session.title}</h5>
              <p className="mb-0">
                {moment(session.sessionDate).format("MMMM D, YYYY")}
              </p>
            </div>
            <DeleteModal
              title={"Delete"}
              content1={"Are you sure you want to delete"}
              content2={"this Session?"}
              modalId={"deleteSession"}
              button2={"No"}
              button1={"Yes"}
              onDelete={() => deleteSession(sessionId)}
            />
            <div className="d-flex align-items-center">
              <button
                disabled={!canStartSession}
                className="btn btn-primary btn-custom-light ms-3"
               
                onClick={() =>
                  onStartSession(session?.sessionLink_doctor)
                }
                style={{
                  backgroundColor: canStartSession ? null : "#d81010",
                }}
              >
                <RiPlayFill className="me-2" />
                Join Session
                {/* {canStartSession ? "Join Session" : "Session Completed"} */}
              </button>
              <button
                className="btn btn-primary btn-custom-light ms-3"
                onClick={() => {
                  setViewSession(true);
                  setSession(session);
                }}
              >
                <RiEyeFill className="me-2" /> View Session
              </button>
              <div className="dropdown ms-5">
                <button
                  onBlur={() => {
                    setDropDown(false);
                  }}
                  onClick={() => {
                    setDropDown(!dropDown);
                  }}
                  className="btn primary tn-custom position-relative text-muted"
                  type="button"
                >
                  <IoIosMore className="me-2" style={{ fontSize: "1.5rem" }} />
                  <ul
                    className={drop + " top-0 end-0 w-100"}
                    style={{ marginTop: "2.5em" }}
                  >
                    <li>
                      <a
                        className="dropdown-item pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#sessionModal"
                        onClick={() => {
                          setSessionApiChange("edit");
                          setSessionId(session._id);
                          getSIngleSessionById(session._id);
                        }}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        data-bs-toggle="modal"
                        data-bs-target="#deleteSession"
                        onClick={() => {
                          setSessionId(session._id);
                        }}
                        className="dropdown-item pointer text-danger"
                      >
                        Delete
                      </a>
                    </li>
                  </ul>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const renderSessionList = () => {
    let data = getSessionList;
    if (data.length === 0) {
      return (
        <Loader
          textClassName={`mt-0`}
          showBR={false}
          emptyTextKey={`noData`}
          mainClassName={`active_n0data2`}
        />
      );
    }
    if (data.length > 0) {
      getSessionList.sort((a, b) => new Date(b.sessionDate) - new Date(a.sessionDate))
      return getSessionList.map((session, index) => {
        return <RenderSesstionItem session={session} key={index} />
      });
    }
  };
  const renderForm = () => {
    return (
      <form onSubmit={handleSubmitSession}>
        <div className="row">
          <div className="col-md-12">
            <p className="whole_label resFont">
              session <span className="small_letter2">title</span>
              <span className="text-danger"> *</span>
            </p>
            <input
              type="text"
              placeholder="E.g. Sample session"
              className="description_inputf mb-4"
              value={sessionName}
              onChange={(e) => {
                setSessionName(e.target.value);
                setError({ ...error, sessionName: false });
              }}
            />
            {renderError("Please enter name", error.sessionName)}
          </div>
          <div className="col-md-12">
            <p className="whole_label resFont">
              description<span className="text-danger"> *</span>
            </p>
            <textarea
              rows="6"
              type="text"
              className="description_inputf description_descpf is-invalid mb-4"
              placeholder="Please add description..."
              value={description}
              onChange={(e) => {
                setError({ ...error, description: false });
                setDescription(e.target.value);
              }}
            />
            {renderError("Please enter description", error.description)}
          </div>
          <div className="col-md-12">
            <p className="whole_label resFont">
              date <span className="small_letter2"></span>
              <span className="text-danger"> *</span>
            </p>
            <DateInput
              value={sessionDate}
              placeHolder={"Please choose..."}
              onChangeDate={(date) => {
                setSessionDate(date);
                // getTimeSlots(format(date, "yyyy-MM-dd"));
                setError({ ...error, sessionDate: false });
                // console.log(date);
              }}
              imageStyle={{
                width: "22px",
                height: "22px",
                position: "absolute",
                borderRadius: "0px",
                marginBlock: "17px",
                left: "20px",
              }}
              maxDate={endDateCreate}
              // minDate={new Date()}
              minDate={startDateCreate}
              inputClassName={"description_inputf d-flex align-items-center"}
            />
            {renderError("Please select date session", error.sessionDate)}
          </div>
          <div className="col-md-6">
            <p className="whole_label resFont">
              Duration <span className="small_letter2"></span>
              <span className="text-danger"> *</span>
            </p>
            <select
              name=""
              id=""
              className="px-3 py-3 description_inputf"
              style={{ color: "rgba(107, 118, 126, 1)" }}
              value={Duration}
              onChange={(e) => {
                setDuration(e.target.value);
                // console.log(e.target.value);
              }}
              placeholder="Please Select Duration"
            >
              <option value="" disabled selected className="">
                {" "}
                <img src={DurationSvg} alt=""></img> Please Select Duration
              </option>
              {/* <option value="30">30</option> */}
              <option value="60">60</option>
              <option value="90">90</option>
              <option value="90">120</option>
            </select>
            {renderError("Please select date session", error.sessionDate)}
          </div>
          <div className="col-md-12">
            <p className="whole_label resFont">
              Available<span className="small_letter2"> times: </span>
            </p>
            {renderError("Please select session time", error.startTime)}
            <div
              className="d-flex justify-content-space-between memlist_scroll mt-1 spacing_scroll"
              style={{ height: 200 }}
            >
              <div className="col-md-8">
                {timeList.length ? (
                  timeList.map((dt, i) => (
                    <div
                      key={i}
                      // className={`card mb-2 p-1 ${index == 0 ? "active" : ""}`}
                      className={` px-3`}
                      // style={{ background: "#F2F4F6" }}
                      // onClick={() => {
                      // }}
                      id={i}
                    >
                      <p style={{ fontSize: "14px", marginLeft: "-5px" }}>
                        <div className="form-group">
                          <label>
                            <input
                              type="checkbox"
                              name="members"
                              value={sessionStartTime}
                              checked={
                                formatAMPM(dt.start) ===
                                formatAMPM(sessionStartTime)
                                  ? true
                                  : false
                              }
                              id={"flexCheckDefault"}
                              onChange={() => {
                                setSessionStartTime(dt.start);
                                setSessionEndTime(dt.end);
                                setError({ ...error, startTime: false });
                              }}
                            />
                            <span
                              className="affir_checkbox"
                              style={{ marginLeft: "8px", marginRight: "5px" }}
                            >
                              Group Session
                            </span>
                            {formatAMPM(dt.start) + " - " + formatAMPM(dt.end)}
                          </label>
                        </div>
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="resFont">No slots available</p>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-12">
            <p className="whole_label resFont mt-2">
              Add Location<span className="text-danger"> *</span>
            </p>
            <div className="btn-group">
              <p className="affir_checkbox">
                <input
                  type="checkbox"
                  checked={zoomlink}
                  onClick={() => {
                    setZoomlink(!zoomlink);
                    // console.log(zoomlink);
                    // setError({ ...error, zoomlink: false });
                  }}
                />
              </p>
              <p
                className="affir_checkbox"
                style={{ fontSize: 16, color: "#156563" }}
              >
                {"Create zoom meeting link"}
              </p>
            </div>
            <input
              type="text"
              disabled={zoomlink ? true : false}
              className="description_inputf mb-4"
              placeholder="Type physical  address or leave blank if online only"
              value={meetLocation}
              onChange={(e) => {
                setMeetLocation(e.target.value);
                // console.log(meetLocation);
              }}
            />
            {/* {renderError("Please enter Zoomlink", error.zoomlink)} */}
          </div>

          <div>
            <hr className="mt-4 px-3" />
            <div className="d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-secondary blogbtn_widfix"
                style={{ width: "120px", height: "50px" }}
                data-bs-dismiss="modal"
              >
                <b>Cancel</b>
              </button>
              <Button
                data-bs-dismiss="modal"
                aria-label="Close"
                isLoading={isSubmit}
                disabled={isSubmit}
                type="submit"
                id="reateProgram"
                text={sessionApiChange === "edit" ? "Update Session" : "Next"}
                style={
                  isSubmit
                    ? { cursor: "none" }
                    : { width: "max-content", marginLeft: 0 }
                }
                className="description_btnsave "
              />
            </div>
          </div>
        </div>
      </form>
    );
  };

  return !viewSession ? (
    <div className="container">
      <div className="my-4">
        <h2 className="chidHeadFont">Upcoming Sessions</h2>
        {/* <p className="resFont">Gravida vestibulum felis tristique lectus elementum. Amet ut est cursus sociis.</p> */}
      </div>
      <div className="table_resouter mt-4">
        {isLoading ? (
          <center>
            <div
              style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
              class="spinner-border mt-3 mb-4"
              role="status"
            />
          </center>
        ) : getSessionList === "" ? (
          <Loader
            textClassName={`mt-0`}
            showBR={false}
            emptyTextKey={`noData`}
            mainClassName={`active_n0data2`}
          />
        ) : (
          renderSessionList()
        )}
      </div>
      <ActiveSessionModel
        renderForm={() => renderForm()}
        isLoading={isLoading}
        sessionApiChange={sessionApiChange}
      />
    </div>
  ) : (
    <ViewSession
      getSessionById={() => getSessionById()}
      state={session}
      toggle="modal"
      target="#sessionModal"
      content={
        <>
          <div className="d-flex">
            <button
              className="btn btn-primary btn-custom-tag py-2 "
              onClick={() => !isLoading && setViewSession(false)}
            >
              <IoArrowBack /> &nbsp;&nbsp;&nbsp; All Sessions
            </button>
          </div>
        </>
      }
      onclick={() => {
        setSessionApiChange("edit");
        setSessionId(session._id);
        getSIngleSessionById(session._id);
      }}
    />
  );
};

export default ActiveSessionView;
